// components/CampoPdfEditable.jsx
import React from "react";
import { Form, Input } from "antd";

const CampoPdfEditable = ({ name, generandoPDF }) => {
  const form = Form.useFormInstance?.();
  const valorCampo = form?.getFieldValue(name);

  return generandoPDF ? (
    <div
      style={{
        width: "100%",
        whiteSpace: "pre-wrap",
        lineHeight: "1.4em",
        backgroundColor: "#fff",
        fontSize: 14,
        fontFamily: "Arial, sans-serif",
        boxSizing: "border-box",
        overflowY: "auto",
        resize: "none",
      }}
    >
      {valorCampo || ""}
    </div>
  ) : (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <Form.Item name={name} noStyle>
        <Input.TextArea
          variant="borderless"
          autoSize // se adapta automáticamente al contenido
          style={{
            width: "100%",
            resize: "none",
            overflowX: "hidden",
            overflowY: "auto",
            lineHeight: "1.4em",
            fontSize: "14px"
          }}
        />
      </Form.Item>
    </div>
  );
};

export default CampoPdfEditable;
